import type { GetStaticPaths, GetStaticProps } from 'next';

import { EntryContentTypeFieldsEnum } from '@seuk/cms-api-client';
import { LOCALES } from '@seuk/shared-data';

import { makeStaticPropsRequest } from '../../modules/page-info';
import { makePage } from '../../modules/page-info/page';
import { makePagePropsProvider } from '../../modules/page-info/page-props-provider';
import type { PageProps, UrlParams } from '../../modules/page-info/types';
import { getCMSClient } from '../../services/cms';

export const getStaticProps: GetStaticProps<PageProps, UrlParams> = ({ params, preview }) =>
  makeStaticPropsRequest(
    `/policies/${params.policyUrlName}`,
    `No ${params.policyUrlName} page entry found`
  )({ preview: preview });

const PageComponent = makePage();
const Page = makePagePropsProvider<typeof getStaticProps>(PageComponent);

export const getStaticPaths: GetStaticPaths<UrlParams> = async () => {
  const entries = (
    await Promise.all(
      LOCALES.map((locale) =>
        getCMSClient().getAllEntries({ contentType: EntryContentTypeFieldsEnum.PageInfo, query: { locale } })
      )
    )
  )
    .flat()
    .filter(({ fields }) => fields.slug.startsWith('/policies/'));

  return {
    paths: entries.map(({ fields }) => ({
      params: { policyUrlName: fields.slug.split('/policies/')[1] },
    })),
    fallback: 'blocking',
  };
};

export default Page;
